import { useEffect } from "react";
import { useStore } from "zustand";
import { useDashboardName } from "../../store/headerName";
import { Form } from "antd";
import FormCard from "../../components/card/FormCard";
import FormButton from "../../components/FormButton";
import FormItemInput from "../../components/form-item/form-item-input";
import FormItemInputNumber from "../../components/form-item/form-item-input-number";
import { $api } from "../../helper";
import FormItemInputSelect from "../../components/form-item/form-item-input-select";
import { statusShowMock, tokenMock } from "../../helper/mock";
import { requireRules } from "../../helper/method";
import { useNotify } from "../../helper/notify";
import { useNavigate, useSearchParams } from "react-router";

export default function AddShippingMethod() {
  const [form] = Form.useForm();
  const notify = useNotify();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const u_id = searchParams.get("u_id");
  const { mutate, isPending } = $api.useMutation(
    "post",
    "/site-api/v1/shipping/",
  );
  const update = $api.useMutation("put", "/site-api/v1/shipping/");
  const detail = $api.useMutation("get", "/site-api/v1/shipping-detail/");
  const { setDashboardName } = useStore(useDashboardName);
  useEffect(() => {
    setDashboardName("اضافه کردن روش ارسال");
    if (u_id) {
      detail.mutate(
        {
          params: {
            query: {
              shipping_u_id: u_id,
            },
          },
          headers: {
            Authorization: tokenMock,
            lang: "fa",
          },
        },
        {
          onSuccess: (data) => {
            form.setFieldsValue({
              ...data.data,
              status: data.data.status.toString(),
              display_order: data.data.display_order.toString(),
            });
          },
        },
      );
    }
  }, []);

  const onFinish = (
    values: {
      title: string;
      price: number;
      display_order: number;
      status: number;
    },
    redirect = true,
  ) => {
    if (u_id) {
      update.mutate(
        {
          body: { ...values, shipping_u_id: u_id },
          headers: {
            Authorization: tokenMock,
            lang: "fa",
          },
        },
        {
          onSuccess: (data) => {
            notify.success(data.message);
            if (redirect) {
              navigate("/shipping-method");
            } else {
              setTimeout(() => {
                window.location.href = window.location.pathname;
              }, 1000);
            }
          },
        },
      );
    } else {
      mutate(
        {
          body: values,
          headers: {
            Authorization: tokenMock,
            lang: "fa",
          },
        },
        {
          onSuccess: (data) => {
            notify.success(data.message);
            if (redirect) {
              navigate("/shipping-method");
            } else {
              setTimeout(() => {
                window.location.href = window.location.pathname;
              }, 1000);
            }
          },
        },
      );
    }
  };

  return (
    <Form
      form={form}
      onFinish={onFinish}
      layout="vertical"
      className="flex! flex-col! gap-6!"
    >
      <FormCard
        title="اطلاعات روش ارسال"
        subTitle="تعریف و تنظیمات پایه مربوط به روش ارسال"
      >
        <div className="grid sm:grid-cols-2 grid-cols-1 gap-6">
          <FormItemInput
            rules={requireRules("نام روش ارسال")}
            name={"title"}
            label="نام روش ارسال"
            className="col-span-1"
          />
          <FormItemInputNumber
            rules={requireRules("قیمت روش ارسال")}
            name={"price"}
            label="قیمت روش ارسال"
            className="col-span-1"
          />
          <FormItemInputNumber
            rules={requireRules("ترتیب روش ارسال")}
            name={"display_order"}
            label="ترتیب نمایش"
            className="col-span-1"
          />
          <FormItemInputSelect
            rules={requireRules("وضعیت روش ارسال")}
            name={"status"}
            inputProps={{
              options: statusShowMock,
            }}
            label="وضعیت روش ارسال"
            className="col-span-1"
          />
        </div>
      </FormCard>
      <FormButton
        isPending={isPending || update.isPending}
        ActionSaveAndStay={() => {
          form.validateFields().then(() => {
            onFinish(form.getFieldsValue(), false);
          });
        }}
      />
    </Form>
  );
}
